const _import = file => () => import('@/views/' + file + '.vue')

export default [
     {
        path: '/warning/healthCert',
        name: 'warning.healthCert',
        component: _import('warning/healthCert')
    },
    {
        path: '/warning/food',
        name: 'warning.food',
        component: _import('warning/food')
    },
    {
        path: '/warning/licence',
        name: 'warning.licence',
        component: _import('warning/licence')
    },
    {
        path: '/warning/trace',
        name: 'warning.trace',
        component: _import('warning/trace')
    },
    {
        path: '/warning/check',
        name: 'warning.check',
        component: _import('warning/check')
    },
    {
        path: '/warning/complaint',
        name: 'warning.complaint',
        component: _import('warning/complaint')
    },
    {
        path: '/warning/supervise',
        name: 'warning.supervise',
        component: _import('warning/supervise')
    },
    {
        path: '/warning/kitchen',
        name: 'warning.kitchen',
        component: _import('warning/kitchen')
    },
    {
        path: '/warning/AIWarn',
        name: 'warning.AIWarn',
        component: _import('warning/AIWarn')
    },
    {
      path: '/warning/assessStatistics',
      name: 'warning.assessStatistics',
      component: _import('warning/assessStatistics')
  },
    {
      path: '/warning/AIWarnDetail',
      name: 'warning.AIWarnDetail',
      component: _import('warning/AIWarnDetail')
    },
    // 预警2.0页面
    {
      path: '/warning2.0/healthCert',
      name: 'warning2.0.healthCert',
      component: _import('warning2.0/healthCert')
  },
  {
      path: '/warning2.0/food',
      name: 'warning2.0.food',
      component: _import('warning2.0/food')
  },
  {
      path: '/warning2.0/licence',
      name: 'warning2.0.licence',
      component: _import('warning2.0/licence')
  },
  {
      path: '/warning2.0/trace',
      name: 'warning2.0.trace',
      component: _import('warning2.0/trace')
  },
  {
      path: '/warning2.0/check',
      name: 'warning2.0.check',
      component: _import('warning2.0/check')
  },
  {
      path: '/warning2.0/complaint',
      name: 'warning2.0.complaint',
      component: _import('warning2.0/complaint')
  },
  {
      path: '/warning2.0/supervise',
      name: 'warning2.0.supervise',
      component: _import('warning2.0/supervise')
  },
  {
      path: '/warning2.0/kitchen',
      name: 'warning2.0.kitchen',
      component: _import('warning2.0/kitchen')
  },
  {
      path: '/warning2.0/AIWarn',
      name: 'warning2.0.AIWarn',
      component: _import('warning2.0/AIWarn')
  },
  {
    path: '/warning2.0/assessStatistics',
    name: 'warning2.0.assessStatistics',
    component: _import('warning2.0/assessStatistics')
},
  {
    path: '/warning2.0/AIWarnDetail',
    name: 'warning2.0.AIWarnDetail',
    component: _import('warning2.0/AIWarnDetail')
  },
    //来源填报
    {//商品填报
      path: '/kitchenManage/sourceFill/goodsFill',
      name: 'sourceFill.goodsFill',
      component: _import('sourceFill/goodsFill')
    },
    {//商品填报添加编辑
      path: '/kitchenManage/sourceFill/goodsFillAdd',
      name: 'sourceFill.goodsFillAdd',
      component: _import('sourceFill/goodsFillAdd')
    },
    {//商品填报详情
      path: '/kitchenManage/sourceFill/goodsFillInfo',
      name: 'sourceFill.goodsFillInfo',
      component: _import('sourceFill/goodsFillInfo')
    },
    {//供应商管理
      path: '/kitchenManage/sourceFill/supplierFill',
      name: 'sourceFill.supplierFill',
      component: _import('sourceFill/supplierFill')
    },
    {//供应商管理添加编辑
      path: '/kitchenManage/sourceFill/supplierFillAdd',
      name: 'sourceFill.supplierFillAdd',
      component: _import('sourceFill/supplierFillAdd')
    },
    {//供应商管理添加详情
      path: '/kitchenManage/sourceFill/supplierFillInfo',
      name: 'sourceFill.supplierFillInfo',
      component: _import('sourceFill/supplierFillInfo')
    },
    {//来源管理
      path: '/kitchenManage/sourceFill/sourceFill',
      name: 'sourceFill.sourceFill',
      component: _import('sourceFill/sourceFill')
    },
    {//来源管理添加编辑
      path: '/kitchenManage/sourceFill/sourceFillAdd',
      name: 'sourceFill.sourceFillAdd',
      component: _import('sourceFill/sourceFillAdd')
    },
    {//来源管理添加详情
      path: '/kitchenManage/sourceFill/sourceFillInfo',
      name: 'sourceFill.sourceFillInfo',
      component: _import('sourceFill/sourceFillInfo')
    },
    {//常用商品管理
      path: '/kitchenManage/sourceFill/oftenGoodsFill',
      name: 'sourceFill.oftenGoodsFill',
      component: _import('sourceFill/oftenGoodsFill')
    },
    {//溯源检测
      path: '/kitchenManage/sourceFill/detectionIndex',
      name: 'sourceFill.detectionIndex',
      component: _import('sourceFill/detectionIndex')
    },
    {//库存台账
      path: '/kitchenManage/sourceFill/inventoryBook',
      name: 'sourceFill.inventoryBook',
      component: _import('sourceFill/inventoryBook')
    }
]